import React from "react";

const InputCounter = (props) => {
	const decrement = () => {
		if (!props.isNegative && props.value <= 0) {
			return;
		}
		props.setValue(props.value - props.countBy);
	};

	const increment = () => {
		if (props.maxValue !== null && props.value >= props.maxValue) {
			return;
		}
		props.setValue(props.value + props.countBy);
	};

	return (
		<div className="ctrl">
			<div className="ctrl__button ctrl__button--decrement" onClick={decrement}>
				–
			</div>
			<div className="ctrl__counter">
				<input className="ctrl__counter-input" type="hidden" value={props.value}/>
				<div className="ctrl__counter-num">{props.value}</div>
			</div>
			<div className="ctrl__button ctrl__button--increment" onClick={increment}>
				+
			</div>
		</div>
	);
};

InputCounter.defaultProps = {
	countBy: 1,
	value: 0,
	isNegative: false,
	maxValue: null,
};

export default InputCounter;
